import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"
import { add, mul, sub } from './util' 
import { stat } from 'fs';

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    osshttp: 'https://sxxsimg.oss-cn-qingdao.aliyuncs.com/',
    imgPlaceHolder: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACCAYAAABytg0kAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAATSURBVBhXY/j69et/EIYyvv4HAIsOD3nZw9VMAAAAAElFTkSuQmCC',
    comhttp:'https://www.sxxskw.com/MyNosql/',
    isLogin:false,
    toUser:'',
    wwzqx:'',
    modules:[],
    userfunc:[],
    wwzmod:[],
    footlist:[],
    custname:'',
    loginname:'',
    urls:[],
    delIndex:0

  },  
  getters: {
    tabs_active: state => {
      console.log("---"+state.delIndex)
      if(state.urls.length>=1){ 
        return state.urls[state.delIndex].name;
      }else{
        return "";
      }
    }, 
  },
  mutations: { 
    setData(state,parms){
      state.toUser = parms.toUser; 
      state.wwzqx = parms.wwzqx; 
      state.modules = parms.modules; 
      state.wwzmod = parms.wwzmod; 
      state.footlist = parms.footlist; 
      state.custname = parms.custname;
      state.userfunc=parms.userfunc; 
      state.loginname = parms.loginname;
      state.isLogin=true;  
    },
    logout(state){
      state.toUser = ''; 
      state.wwzqx =''; 
      state.modules =[]; 
      state.wwzmod = []; 
      state.footlist =[]; 
      state.userfunc=[]; 
      state.custname = ''; 
      state.isLogin =false;
      state.loginname ='';
      state.urls=[]; 
    },
    addUrl(state,parms){
      let isIn=false;
      state.urls.forEach((url,index)=>{
        if(url.name===parms.name){
          isIn=true; 
          state.delIndex=index;
        }
      });
      if(!isIn){
        state.urls.push(parms); 
        if(state.urls.length-1>0){
          state.delIndex=state.urls.length-1;
        }else{
          state.delIndex=0;
        } 
        
      }
      
      
     
    },
    delUrl(state,name){
      state.urls.forEach((url,index)=>{
        if(url.name===name){
          if(index-1>0){
            state.delIndex=index-1;
          }else{
            state.delIndex=0;
          }
         
        }
      });
      state.urls=state.urls.filter(url => url.name!==name);
    },
    clearUrl(state){
      state.urls=[];
    }

  },
  actions: {
    setData(context, parms) {
      context.commit('setData', parms)
    },
    logout(context) {
      context.commit('logout')
    }, 
    addUrl(context,url) {
      context.commit('addUrl',url)
    },
    delUrl(context,name) {
      context.commit('delUrl',name)
    },
    clearUrl(context) {
      context.commit('clearUrl')
    }, 
  }
})
